import React, { Fragment, useState, useEffect } from 'react';
import {
  CButton,
  CCardBody,
  CCollapse,
  CDataTable,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CForm,
  CRow,
  CCol,
  CInput,
  CFormText,
} from '@coreui/react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { CSpinner } from '@coreui/react';
import UserForm from '../containers/UserForm';
import SpinnerWithContainer from '../components/SpinnerWithContainer';
import AddItem from '../components/addItem';
import LoaderButton from '../components/LoaderButton';
import { useActions } from '../hooks/useActions';
import {
  getUsers,
  deleteUser,
  resendInvitation,
  exportData,
  RefetchData,
} from '../actions/usersActions';
import CategoryService from '../services/categories.service';

const fields = [
  { key: '_id', label: 'ID' },
  { key: 'name', label: 'Category' },
  {
    key: 'show_details',
    label: 'Options',
    sorter: false,
    filter: false,
  },
];

const Categories = () => {
  // get users from store
  const { deletingUser } = useSelector((state) => state.users);

  // bind dispatch to action creators
  const [getUsersAction] = useActions([
    getUsers,
    deleteUser,
    resendInvitation,
    exportData,
    RefetchData,
  ]);

  // component state
  const [details, setDetails] = useState([]);
  const [updateItem, setUpdateItem] = useState({ _id: '', name: '' });
  const [selectedUser, setSelectedUser] = useState();
  const [currentlyDeletingCat, setCurrentlyDeletingCat] = useState('');
  const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [categories, setCategories] = useState([]);
  const [isloading, setIsloading] = useState({
    get: false,
    delete: false,
    add: false,
  });

  // useEffect to fetch users
  useEffect(() => {
    // getUsersAction();
    getCategories();
  }, [getUsersAction]);

  const getCategories = async () => {
    setIsloading({ ...isloading, get: true });
    try {
      const res = await CategoryService.get();
      setCategories(res.data);
      setIsloading({ ...isloading, get: false });
    } catch (e) {
      setIsloading({ ...isloading, get: false });
      console.log('er', e);
    }
  };

  const updateSelectedItem = (index) => {
    setUpdateItem({ ...updateItem, ...categories[index] });
    setUpdateModal(true);
  };

  const handleCategoryDelete = async () => {
    setIsloading({ ...isloading, delete: true });
    try {
      await CategoryService.delete(currentlyDeletingCat);
      setIsloading({ ...isloading, delete: false });
      setCategories(
        categories.filter((item) => item._id != currentlyDeletingCat)
      );
      setDeleteConfirmationModal(false);
    } catch (e) {
      setDeleteConfirmationModal(false);
      console.log(e);
    }
  };

  const addCategory = async (name) => {
    setIsloading({ ...isloading, add: true });
    try {
      const { data } = await CategoryService.add(name);
      let updatedCategories = [...categories];
      updatedCategories.push(data);
      setCategories(updatedCategories);
      setAddModal(false);
      setIsloading({ ...isloading, add: false });
    } catch (e) {
      setIsloading({ ...isloading, add: false });
      console.log(e);
    }
  };

  const validationSchema = Yup.object().shape({
    _id: Yup.string().required('Required'),
    name: Yup.string().required('Required'),
  });
  // initialize form with formik
  const { handleChange, handleSubmit, values, errors, touched } = useFormik({
    initialValues: {
      _id: updateItem && updateItem._id ? updateItem._id : '',
      name: updateItem && updateItem.name ? updateItem.name : '',
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (value) => {
      try {
        const res = await CategoryService.update(values._id, values.name);
        let newCategoires = [...categories];
        const index = newCategoires.findIndex(
          (item) => item._id === values._id
        );
        newCategoires[index] = res.data;
        setCategories(newCategoires);
        setUpdateModal(false);
      } catch (e) {
        console.log(e);
      }
    },
  });

  return (
    <Fragment>
      <h1>Categories</h1>
      <LoaderButton
        title="Add new"
        className="option float-right"
        color="primary"
        shape="square"
        size="md"
        onClick={() => setAddModal(true)}
      />
      <AddItem
        addModal={addModal}
        setAddModal={setAddModal}
        addCategory={addCategory}
        isloading={isloading.add}
      />
      <Fragment>
        <CModal
          show={deleteConfirmationModal}
          onClose={() => setDeleteConfirmationModal(false)}
        >
          <CModalHeader closeButton>Delete Category</CModalHeader>
          <CModalBody>
            Are you sure you want to delete?
            {isloading.delete ? (
              <div className="text-center mt-2">
                <CSpinner color="info" />
              </div>
            ) : null}
          </CModalBody>
          <CModalFooter>
            <CButton
              color="danger"
              onClick={() => {
                handleCategoryDelete();
              }}
            >
              Delete
            </CButton>
            <CButton
              color="secondary"
              onClick={() => {
                setDeleteConfirmationModal(false);
              }}
            >
              Cancel
            </CButton>
          </CModalFooter>
        </CModal>
        <CModal show={updateModal} onClose={() => setUpdateModal(false)}>
          <CForm className="p-sm-3 p-3" onSubmit={handleSubmit}>
            <CModalHeader closeButton>Update</CModalHeader>
            <CModalBody>
              <CRow className="p-2">
                <CCol sm="12" md="4" className="xs-margin">
                  <label className="text-swtich">ID </label>
                  <CInput name="ID" disabled value={values._id} />
                </CCol>
                <CCol sm="12" md="4" className="xs-margin">
                  <label className="text-swtich">Category</label>
                  <CInput
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                  />
                  {errors.name && touched.name && (
                    <CFormText color="danger" className="help-block">
                      {errors.name}
                    </CFormText>
                  )}
                </CCol>
              </CRow>
            </CModalBody>
            <CModalFooter>
              <LoaderButton title="Update" type="submit" />
              <CButton
                color="primary"
                onClick={() => {
                  setUpdateModal(false);
                }}
              >
                Cancel
              </CButton>
            </CModalFooter>
          </CForm>
        </CModal>
        {isloading.get ? (
          <SpinnerWithContainer />
        ) : (
          <CDataTable
            items={categories}
            itemsPerPage={2}
            fields={fields}
            tableFilter
            responsive
            scopedSlots={{
              show_details: (item, index) => {
                return (
                  <td className="py-2">
                    <LoaderButton
                      title="Update"
                      className="option"
                      color="primary"
                      variant="outline"
                      shape="square"
                      size="sm"
                      onClick={() => updateSelectedItem(index)}
                    />
                    <LoaderButton
                      title="Delete"
                      loading={deletingUser && item.id === currentlyDeletingCat}
                      disabled={
                        deletingUser && item.id === currentlyDeletingCat
                      }
                      className="option m-xs-2"
                      color="primary"
                      variant="outline"
                      shape="square"
                      size="sm"
                      onClick={() => {
                        setCurrentlyDeletingCat(item._id);
                        setDeleteConfirmationModal(true);
                      }}
                    />
                  </td>
                );
              },
              details: (item, index) => {
                return (
                  <CCollapse show={details.includes(index)}>
                    <CCardBody>
                      <UserForm data={selectedUser} />
                    </CCardBody>
                  </CCollapse>
                );
              },
            }}
          />
        )}
      </Fragment>
      {/* // )} */}
      {/* <div className="d-flex flex-row">
        <div className="d-flex invite-user-link" onClick={() => setModal(true)}>
          <CIcon name="cil-people" className="people-icon" />
          <h4 className="ml-2">Invite User</h4>
        </div>
        {modal && <InviteUserForm modal={modal} setModal={setModal} />}
      </div> */}
    </Fragment>
  );
};

export default Categories;
